export const theme = {
  colors: {
    cream: "#fff6e8",
    warm: "#ffd38f",
    gold: "#c69235",
    goldDark: "#8d6424",
    brown: "#30261d",
    brownSoft: "#5c4334",
    teal: "#22778b",
    tealDark: "#155564",
    white: "#ffffff",
    line: "rgba(48, 38, 29, 0.14)",
  },
  fonts: {
    heading: "'Playfair Display', Georgia, serif",
    body: "'Montserrat', 'PT Sans Caption', Arial, sans-serif",
  },
  layout: {
    maxWidth: "1180px",
  },
};
